<template>
  <div class="invoice-box">
    <div class="row">
      <div class="col-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="177"
          height="29.944"
          viewBox="0 0 177 29.944"
        >
          <g transform="translate(-478.85 106.927)">
            <g transform="translate(478.85 -106.927)">
              <g>
                <path
                  d="M490.888-81.862a7.169,7.169,0,0,1-7.162-7.16v-8.155h2.687v8.155a4.481,4.481,0,0,0,4.475,4.476,4.481,4.481,0,0,0,4.475-4.476V-99.364H478.85v-7.563h24.077v2.686H481.537v2.192H498.05v13.027A7.169,7.169,0,0,1,490.888-81.862Z"
                  transform="translate(-478.85 106.927)"
                ></path>
              </g>
              <g transform="translate(0 4.879)">
                <path
                  d="M490.888-77.249A12.054,12.054,0,0,1,478.85-89.287v-8.155h2.687v8.155a9.361,9.361,0,0,0,9.35,9.351,9.363,9.363,0,0,0,9.351-9.351v-13.027h2.687v13.027A12.054,12.054,0,0,1,490.888-77.249Z"
                  transform="translate(-478.85 102.314)"
                ></path>
              </g>
            </g>
            <g transform="translate(511.969 -100.868)">
              <path
                d="M512.31-84.306a8.4,8.4,0,0,1-2.145-6.183v-10.459h3.441v10.327q0,5.456,4.713,5.455,4.686,0,4.687-5.455v-10.327H526.4v10.459a8.429,8.429,0,0,1-2.131,6.183,8.012,8.012,0,0,1-5.97,2.158A8.054,8.054,0,0,1,512.31-84.306Z"
                transform="translate(-510.165 101.212)"
              ></path>
              <path
                d="M546.577-100.153a6.1,6.1,0,0,1,2.74,2.277,6.368,6.368,0,0,1,.953,3.521,6.388,6.388,0,0,1-.953,3.509,6.077,6.077,0,0,1-2.74,2.29,10.262,10.262,0,0,1-4.2.794H538.2v5.348h-3.443v-18.535h7.625A10.262,10.262,0,0,1,546.577-100.153Zm-.94,8.525a3.323,3.323,0,0,0,1.164-2.728,3.322,3.322,0,0,0-1.164-2.727,5.29,5.29,0,0,0-3.416-.953H538.2v7.36h4.024A5.29,5.29,0,0,0,545.637-91.627Z"
                transform="translate(-508.748 101.212)"
              ></path>
              <path
                d="M559.393-82.743a8.648,8.648,0,0,1-3.163-1.615l1.191-2.675a9.373,9.373,0,0,0,2.794,1.47,10.144,10.144,0,0,0,3.322.569,5.745,5.745,0,0,0,3.085-.662,2.006,2.006,0,0,0,1.019-1.747,1.7,1.7,0,0,0-.569-1.311,4,4,0,0,0-1.444-.807q-.874-.292-2.383-.662a27.788,27.788,0,0,1-3.429-1.006,5.639,5.639,0,0,1-2.25-1.576,4.241,4.241,0,0,1-.94-2.9,4.948,4.948,0,0,1,.834-2.794,5.653,5.653,0,0,1,2.515-2,10.2,10.2,0,0,1,4.117-.741,13.313,13.313,0,0,1,3.337.424,9.215,9.215,0,0,1,2.832,1.217l-1.085,2.675a10.754,10.754,0,0,0-2.543-1.086,9.53,9.53,0,0,0-2.568-.37,5.367,5.367,0,0,0-3.032.689,2.125,2.125,0,0,0-.992,1.826,1.651,1.651,0,0,0,.569,1.3,4.111,4.111,0,0,0,1.443.794q.874.292,2.384.662a25.127,25.127,0,0,1,3.388.993,5.805,5.805,0,0,1,2.264,1.575,4.155,4.155,0,0,1,.939,2.86,4.888,4.888,0,0,1-.833,2.78,5.67,5.67,0,0,1-2.529,1.986,10.294,10.294,0,0,1-4.131.74A14.139,14.139,0,0,1,559.393-82.743Z"
                transform="translate(-507.511 101.198)"
              ></path>
              <path
                d="M584.717-90.171l-2.938,3.018v4.739h-3.443v-18.535h3.443v9.506l9.16-9.506h3.867l-7.785,8.289,8.261,10.246h-4.024Z"
                transform="translate(-506.237 101.212)"
              ></path>
              <path
                d="M601.453-100.948H604.9v18.535h-3.443Z"
                transform="translate(-504.906 101.212)"
              ></path>
              <path
                d="M614.093-100.948h3.443v15.623h9.691v2.912H614.093Z"
                transform="translate(-504.177 101.212)"
              ></path>
              <path
                d="M633.791-100.948h3.443v15.623h9.69v2.912H633.791Z"
                transform="translate(-503.043 101.212)"
              ></path>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div
      class="row"
      style="background: #eee;font-weight: bold;
    border-bottom: 1px solid #ddd;margin: 20px 0;"
    >
      <div class="col-6">
        Product
      </div>
    </div>
    <div
      class="row justify-content-between"
      style="margin: 20px 0;"
      v-for="i in items"
      :key="i.price"
    >
      <div class="col-8">
        {{ i.description }}
      </div>
      <div class="col-4 text-right">Tk. {{ i.price }}</div>
    </div>
    <div
      class="row"
      style="background: #eee;
    border-bottom: 1px solid #ddd;
    font-weight: bold;margin: 20px 0;"
    >
      <div class="col-6">
        Billing Address
      </div>
    </div>
    <div class="row" style="margin: 20px 0;">
      <div class="col-md-6 col-sm-12">
        <div class="row ">
          <div class="col-3">
            Address
          </div>
          <div class="col">
            <textarea type="text" v-model="item.street" class="iinput" />
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="row" style="padding: 6px 0;">
          <div class="col-3">
            Division
          </div>
          <div class="col">
<!--            <input v-model="item.city" class="iinput" />-->
            <select v-model="item.city" style="padding-left: 5px;border: 0.4px solid grey;height: 26px;">
              <option disabled value="">Please select one</option>
              <option v-for="d in divisions" :key="'div'+d" :value="d">{{ d }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="row" style="padding: 6px 0;">
          <div class="col-3">
            District
          </div>
          <div class="col">
<!--            <input type="text" v-model="item.state" class="iinput" />-->
            <select v-model="item.state" style="padding-left: 5px;border: 0.4px solid grey;height: 26px;">
              <option disabled value="">Please select one</option>
              <option v-for="d in districts" :key="'dis'+d" :value="d">{{ d }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="row" style="padding: 6px 0;">
          <div class="col-3">
            Postal Code
          </div>
          <div class="col">
            <input type="text" v-model="item.zip" class="iinput" />
          </div>
        </div>
      </div>
    </div>
    <div class="row " style="margin: 20px 0">
      <div class="col-12 text-right ">
        <input type="checkbox" v-model="save" /> Save billing information <br />
        <input type="checkbox" v-model="terms" /> I accept that I have read and
        I agree to the
        <a href="https://upskill.com.bd/privacy" target="_blank"
          >terms and conditions</a
        >
      </div>
    </div>

    <div class="row">
      <div class="col mb-center invis">
        <img src="../assets/visa.png" style="max-width: 140px" />
        <img src="../assets/bkash.png" style="max-width: 140px" />
      </div>
      <div class="col text-right order-1 mb-col-full">
        <ubtn @click.prevent.native="proceedWithWS" class="resbtn"
          >Proceed to Payment</ubtn
        >
        <ubtn
          @click.prevent.native="$modal.hide('invoice')"
          textColor="red"
          color="white"
          class="resbtn"
          >Close</ubtn
        >
      </div>
    </div>
  </div>
</template>

<script>
import stateData from '../assets/bd.json'
export default {
  props: ["items", "pid"],
  data() {
    return {
      divisions: [],
      districts: [],
      item: {},
      terms: false,
      save: false,
      productType: "",
      hasBilling: "",
      stateData
    };
  },
  computed: {
    total() {
      return this.items.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
    },
  },
  watch: {
    "$route.query"() {
      // console.log(this.$route.query)
      if (this.$route.query.wid) {
        this.productType = "workshop";
      } else {
        this.productType = "invoice";
      }
    },
    "item.city"() {
      this.generateDistricts(this.item.city)
    }
  },
  created() {
    this.$upskill
      .getBilling()
      .then((res) => {
        this.item = res.data.message;
      })
      .catch(() => {
        this.hasBilling = false;
      });
    this.generateDivisions()
    this.Loaded();
    // console.log(this.$route.query)
  },
  methods: {
    generateDivisions() {
      this.divisions = Object.keys(this.stateData)
    },
    generateDistricts(div) {
      this.districts = this.stateData[div]
    },
    proceed() {
      if (
        !this.item.street ||
        !this.item.city ||
        !this.item.state ||
        !this.item.zip
      ) {
        this.ErrorAlert("Please fill up all the fields");
      } else {
        if (!this.terms) {
          this.ErrorAlert(
            "Please accept the terms and conditions before you continue."
          );
        } else {
          this.saveBilling();
          this.$upskill.purchaseSubscription(this.item).then((res) => {
            window.localStorage.setItem(
              "pendingTransaction",
              res.data.purchase_code
            );
            window.location = res.data.url;
          });
        }
      }
    },
    saveBilling() {
      if (this.save) {
        if (this.hasBilling === true) {
          this.$upskill.updateBilling(this.item).then(() => {});
        } else {
          this.$upskill.addBilling(this.item).then(() => {});
        }
      }
    },
    proceedWithWS() {
      if (
        !this.item.street ||
        !this.item.city ||
        !this.item.state ||
        !this.item.zip
      ) {
        this.ErrorAlert("Please fill up all the fields");
      } else {
        if (!this.terms) {
          this.ErrorAlert(
            "Please accept the terms and conditions before you continue."
          );
        } else {
          this.saveBilling();
          this.$upskill.purchaseWorkshop(this.pid, this.item).then((res) => {
            window.localStorage.setItem(
              "pendingTransaction",
              res.data.purchase_code
            );
            window.location = res.data.url;
          });
        }
      }
    },
  },
  filters: {
    currency(value) {
      return value.toFixed(2);
    },
  },
};
</script>

<style scoped>
.invoice-box {
  max-width: 800px;
  margin: 40px auto;
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;
}

.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
}

.invoice-box table tr td:nth-child(n + 2) {
  text-align: right;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  padding-bottom: 40px;
}

.invoice-box table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.item input {
  padding-left: 5px;
  border: 0.4px solid grey;
}
.invoice-box table tr.item textarea,
.iinput {
  padding-left: 5px;
  border: 0.4px solid grey;
}

.invoice-box table tr.item td:first-child input {
  margin-left: -5px;
  width: 100%;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

.invoice-box input[type="number"] {
  width: 60px;
}

@media only screen and (max-width: 600px) {
  .invis {
    display: none;
  }
  .resbtn {
    font-size: 12px;
    margin: 0px;
    padding: 0px;
  }
  .invoice-box {
    margin: 0;
    padding: 0;
    font-size: 10px;
  }
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
  .mb-center {
    text-align: center !important;
  }

  .mb-col-full {
    order: 1;
    flex: 0 0 100%;
    max-width: 100%;
  }
  /* .billing-info{
    margin: 0px 0!important;
  } */
  .text-right {
    text-align: left !important;
  }
}

/** RTL **/
.rtl {
  direction: rtl;
  font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
    sans-serif;
}

.rtl table {
  text-align: right;
}

.rtl table tr td:nth-child(2) {
  text-align: left;
}
</style>
